<ng-template #vcsAccExpiryAlert let-data let-ref="dialogRef">
  <nb-card style="width: 35rem">
    <nb-card-header class="d-flex justify-content-between align-items-center">
      <h6 style="color: var(--error-text)">
        Attention: VCS Account Tokens Expired
      </h6>
      <nb-icon
        pack="fci"
        icon="close-outline"
        (click)="ref?.close()"
        class="cursor-pointer"
      ></nb-icon>
    </nb-card-header>
    <nb-card-body>
      The following VCS account tokens have expired:
      <a
        href=""
        routerLink="/settings/overlay/organization-accounts/{{ acc?.id }}"
        (click)="ref?.close()"
        *ngFor="let acc of data; let i = index"
        style="text-decoration: none; color: var(--color-primary-active)"
        >{{ acc?.name }}<span *ngIf="i <= data?.length - 2">, </span></a
      >. Please renew your token to avoid release failures and to enable 'sync
      with git'.
    </nb-card-body>
    <nb-card-footer>
      <button
        nbButton
        size="small"
        status="primary"
        class="mr-3"
        (click)="navigateToAccountsPage(ref)"
      >
        Renew Credentials
      </button>
      <button
        size="small"
        nbButton
        (click)="snoozeAlert(ref)"
        nbTooltip="Snoozing would not show this notification for the next 10 days"
      >
        Snooze
      </button>
      <button size="small" nbButton (click)="ref?.close()">Cancel</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
